import { useState } from "react"
import { arrayOf, bool, func, shape, string } from "prop-types"
import { TextInput } from "@planningcenter/doxy-web"

import CustomField from "./CustomField"

TextField.propTypes = {
  errors: arrayOf(
    shape({
      detail: arrayOf(string),
      source: {
        parameter: string,
      },
    }),
  ),
  field: shape({
    attributes: shape({
      description: string,
      label: string.isRequired,
      placeholder: string,
      required: bool.isRequired,
    }),
    id: string.isRequired,
  }),
  onChange: func.isRequired,
}

export default function TextField({ errors, field, onChange }) {
  const [value, setValue] = useState("")
  const {
    attributes: { description, label, placeholder, required },
    id,
  } = field
  const inputId = `field_${id}_value`

  const handleChange = ({ target: { value } }) => {
    setValue(value)
    onChange(value, id)
  }

  return (
    <CustomField {...{ description, errors, label, required }}>
      <TextInput
        id={inputId}
        onChange={handleChange}
        {...{ placeholder, value }}
      />
    </CustomField>
  )
}
